// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { makeUserIdForSelect } from './UsersAndTeamsSearchUtils';
import { formatUserFullNameForDisplay } from '../../utils/UserUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const makeUserSelectOption = (user, userIdsForSelectedTeamIds, disabledUsers) => {
  const {
    id,
    email
  } = user;
  const isMemberOfSelectedTeam = userIdsForSelectedTeamIds.includes(id);
  const isUserDisabled = disabledUsers.includes(id);
  return {
    value: makeUserIdForSelect(id),
    text: formatUserFullNameForDisplay(user),
    isMemberOfSelectedTeam,
    // custom prop used for rendering the disabled tooltip
    isUserDisabled,
    disabled: isMemberOfSelectedTeam || isUserDisabled,
    avatar: /*#__PURE__*/_jsx(UIAvatar, {
      size: "xs",
      displayName: email,
      lookup: {
        type: 'hubSpotUserEmail',
        primaryIdentifier: email
      }
    })
  };
};